// Fee breakdown, same calculation as CreateJobPage2/components/Finish.js.
// The job-posting fee API returns pounds.
// VAT (20%, aka platform commission) is charged on the job posting fee.
// Stripe transaction fee (2.9% + £0.30) is charged on the subtotal.
export const VAT_RATE = 0.2;
const STRIPE_PERCENTAGE = 0.029;
const STRIPE_FIXED_FEE = 0.3;

const toPence = (pounds: number) => Math.round(pounds * 100);

export const getJobPostingFeeBreakdown = (jobPostingFee: number) => {
  const vat = jobPostingFee * VAT_RATE;
  const subtotal = jobPostingFee + vat;
  const transactionFee =
    jobPostingFee > 0 ? subtotal * STRIPE_PERCENTAGE + STRIPE_FIXED_FEE : 0;
  const totalPayable = subtotal + transactionFee;

  return {
    feeCents: toPence(jobPostingFee),
    vatCents: toPence(vat),
    transactionFeeCents: toPence(transactionFee),
    totalCents: toPence(totalPayable),
  };
};
